import { Component, OnInit } from '@angular/core';
import { NavController } from 'ionic-angular';
import {MyUrlService} from '../home/checkUrll';
import {MyvariableService} from '../home/constantvariable';
import {MydataService} from '../home/mydata.service';
import {JsonData} from '../home/dataaa';
import  { Http } from '@angular/http';
import {KiloPartyPage} from "../kiloparty/kiloparty";
import {KiloStorePage} from "../kilostore/kilostore";
import {ProductPage} from "../product/product";
import { Device } from '@ionic-native/device';
import { AlertController } from 'ionic-angular';
import {MycartPage} from '../mycart/mycart';
import { LoadingController } from 'ionic-angular';
import {ProductviewPage} from '../productview/productview';


@Component({
	selector: 'page-kilomenu',
	templateUrl: 'kilomenu.html',
	providers:[MydataService,MyUrlService,JsonData,MyvariableService,Device,MycartPage]
})
export class KiloMenuPage implements OnInit{
	jsonDt : Array<JsonData>;
	productdataDt: Array<JsonData>;
	addtocartDt: Array<JsonData>;
    subcategorydataDt:Array<JsonData>;
	myParseInt = parseInt;
	image:Array<JsonData>;
	pcs = this.MyvariableService.PCS;
	itemPerPack = this.MyvariableService.ITEMPARPACK;
	tax = this.MyvariableService.TAX;
	showDatte:string;
	varDiscount:any;
	showTotalAmt:any;
	finalTotalAmt:any;
	
	constructor(public mycartPage:MycartPage, public device: Device,public loading: LoadingController,public alerCtrl: AlertController,private http:Http,public navCtrl: NavController,private mydataService: MydataService,private myurlService: MyUrlService,private MyvariableService: MyvariableService) {
	}
	
	ngOnInit(){
		
		this.HomeService();
		
		//console.log(this.itemPerPack);
		if(this.mydataService.checkInternetFunction()=="0"){
			//console.log("Internet UnAvailable")
			}else  if(this.mydataService.checkInternetFunction()=="1"){
			var categoryid = window.localStorage.getItem('localid');
			var session_ids=window.localStorage.getItem('session_ids');
			//console.log("menu cat id-->"+categoryid);
			//console.log('Device UUID is: ' + this.device.uuid);
			var kiloSabjiJSONdata = JSON.stringify({"userid":window.localStorage.getItem('userid'),"categoryid":categoryid,"IMEI":session_ids});
			
		//	console.log("Product Url--->"+this.myurlService.PRODUCTURL+"\n"+"JSON Parameter--->"+kiloSabjiJSONdata);
			//		console.log(this.MyvariableService.ITEMPARPACK);
			let loader = this.loading.create({content: '',});
			//this.mydataService.postJSON(this.myurlService.PRODUCTURL ,kiloSabjiJSONdata).subscribe(data => this.jsonDt= data,error => console.log(error),() =>this.hello(loader));
			
			loader.present().then(() => {
				//console.log("Current call start Timestamp==>"+Date.now()+"               "+new Date().getTime());
				this.mydataService.postJSON(this.myurlService.PRODUCTURL ,kiloSabjiJSONdata).subscribe(data => this.jsonDt= data,error =>this.errorFunction(loader,error),() =>this.kiloMenuService(loader));
			});
		}
		
	}
	
	errorFunction= function(loader,error){
		loader.dismiss();
		//console.log(error);
		//alert(error);
	}
	kiloMenuService=function(loader){
		//console.log("Current call end Timestamp==>"+Date.now()+"               "+new Date().getTime());
		//console.log("product receive jsondata ==>"+JSON.stringify(this.jsonDt));
		this.deliverytimes = window.localStorage.getItem('deliverytimes');
		this.productdataDt = this.jsonDt.productdata;
		this.subcategorydataDt= this.jsonDt.subcategorydata;
		this.categorydataDt= this.jsonDt.categorydata;
		this.areanamedataDt= this.jsonDt.areanamedata;
		this.image= this.myurlService.IMAGEURL;
		this.totalcountDt = this.jsonDt.totalcount;
		this.totalcount = this.totalcountDt[0].totalcounts;
		// alert(this.totalcount);
		////console.log("productdata ==>"+JSON.stringify(this.jsonDt.productdata));
		////console.log("subcategorydata ==>"+JSON.stringify(this.jsonDt.subcategorydata))
		////console.log("namedata ==>"+JSON.stringify(this.jsonDt.namedata));
		////console.log("mobilenodata ==>"+JSON.stringify(this.jsonDt.mobilenodata));
		////console.log("func post ---->"+this.postData);
		this.addcartSe();
		//alert(window.localStorage.getItem('subcatid'));
		if(window.localStorage.getItem('subcatid')==null || window.localStorage.getItem('subcatid')=='null'){
			//alert('if');
			}else{
			//alert('else');
			this.catfilter(window.localStorage.getItem('subcatid'));
		}
		loader.dismiss();
		this.showDatte=Date.now();
		//	alert("On Init Start Page "+this.mycartPage.addcartService());
	}
	
	
	
	
	
	
	catfilter(catid){
		window.localStorage.removeItem('subcatid');
		if(this.mydataService.checkInternetFunction()=="0"){
			////console.log("Internet UnAvailable")
			}else  if(this.mydataService.checkInternetFunction()=="1"){
			var subcategoryid = catid;
			//alert(categoryid);
			let loader = this.loading.create({content: '',});
			var categoryid = window.localStorage.getItem('localid');
			var kiloSabjiJSONdata = JSON.stringify({"categoryid":categoryid,"cattype":'filter',"subcategoryid":subcategoryid});
			//console.log("Product Url--->"+this.myurlService.PRODUCTURL+"\n"+"JSON Parameter--->"+kiloSabjiJSONdata);
			loader.present().then(() => {
				this.mydataService.postJSON(this.myurlService.PRODUCTURL ,kiloSabjiJSONdata).subscribe(data => this.jsonDt= data,error => this.errorFunction(loader,error),() =>this.callKiloMenuProd(loader));
			});
		}
	}
	
	callKiloMenuProd=function(loader){
		//console.log("product receive jsondata ==>"+JSON.stringify(this.jsonDt.productdata));
		this.productdataDt = this.jsonDt.productdata;
		this.subcategorydataDt= this.jsonDt.subcategorydata;
		this.image= this.myurlService.IMAGEURL;
		//console.log("productdata ==>"+JSON.stringify(this.jsonDt.productdata));
		//console.log("subcategorydata ==>"+JSON.stringify(this.jsonDt.subcategorydata))
		////console.log("namedata ==>"+JSON.stringify(this.jsonDt.namedata));
		////console.log("mobilenodata ==>"+JSON.stringify(this.jsonDt.mobilenodata));
		////console.log("func post ---->"+this.postData);
		loader.dismiss();
	}
	
	orderQtyFun(miniQty,maxQty, orderQty , checkstatus){
		//console.log('myFunction===>'+miniQty+"   "+maxQty + "  "+ orderQty+"   "+checkstatus);
		if(checkstatus=='subitemm') {
			if (orderQty <= miniQty) { //console.log('min qty false');
				return parseFloat(miniQty);
				} else { //console.log('min qty true');
				return parseFloat(orderQty);
			}
			}else if(checkstatus=='addditem') {
			if ( 0 >= orderQty) { //console.log('min qty false');
				return parseFloat(maxQty);
				} else { //console.log('min qty true');
				return parseFloat(orderQty);
			}
		}
	}
	
	kiloparty(cartid){
		
		window.localStorage.setItem('localid', cartid );
		//this.navCtrl.push(KiloPartyPage);
		this.navCtrl.setRoot(KiloPartyPage);
	}
	
	kilostore(cartid){
		window.localStorage.setItem('localid', cartid );
		//alert(cartid);
		//this.navCtrl.push(KiloStorePage)
		this.navCtrl.setRoot(KiloStorePage);
	}
	
	product(proid, cartid, minQty,maxQty,orderQty,increase) {
		//window.localStorage.setItem('localid', cartid);
		window.localStorage.setItem('proid', proid);
		window.localStorage.setItem('orderQty', orderQty);
		window.localStorage.setItem('minQty', minQty);
		window.localStorage.setItem('maxQty',maxQty);
		window.localStorage.setItem('increase','1');
		//alert(subcategoryid);
		this.navCtrl.push(ProductPage)
	}
	
	addcart(cartid,proid,price,totalamt,orderQty)
	{
		if(this.mydataService.checkInternetFunction()=="0"){
			////console.log("Internet UnAvailable")
			}else  if(this.mydataService.checkInternetFunction()=="1"){
			//console.log('Device UUID is: ' + this.device.uuid);
			//alert("hello IMEI--->"+this.device.uuid);
			var userid = window.localStorage.getItem('userid');
			var session_ids=window.localStorage.getItem('session_ids');
			var kiloSabjiJSONdata = JSON.stringify({"userid":window.localStorage.getItem('userid'),"categoryid":cartid,"productid":proid,"multidata":[],"price":price,"totalamt":totalamt,"IMEI":session_ids,"qty":orderQty});
			//console.log("Product Url--->"+this.myurlService.ADDTOCARTURL+"\n"+"JSON Parameter--->"+kiloSabjiJSONdata);
			let loader = this.loading.create({content: '',});
			
			loader.present().then(() => {
				this.mydataService.postJSON(this.myurlService.ADDTOCARTURL ,kiloSabjiJSONdata).subscribe(data => this.jsonDt= data,error => this.errorFunction(loader,error),() =>this.carrtService(loader));
			});
		}
	}
	
	carrtService=function(loader){
		//console.log("addcart receive jsondata ==>"+JSON.stringify(this.jsonDt.msg));
		var addtocartDt = this.jsonDt.msg;
		this.totalcountDt = this.jsonDt.totalcount;
		this.totalcount = this.totalcountDt[0].totalcounts;
		
		//alert(JSON.stringify(addtocartDt));
		//alert(JSON.stringify(this.totalcount));
		//this.subcategorydataDt= this.jsonDt.subcategorydata;
		//this.image= this.myurlService.IMAGEURL;
		this.addcartSe();
		//console.log("cartdata ==>"+JSON.stringify(this.jsonDt.msg));
		loader.dismiss();
		if(addtocartDt=='Exist'){
			this.addcartalert= this.MyvariableService.EXISTPRODUCT;
			this.showAlert();
			}else{
			this.addcartalert= this.MyvariableService.ADDPRODUCT;
			this.showAlert();
		}
	}
	
	showAlert=function() {
		let alert = this.alerCtrl.create({
			// title: 'New Friend!',
			subTitle: this.addcartalert,
			buttons: ['OK']
		});
		alert.present();
	}
	
	mycart(){  this.navCtrl.push(MycartPage) }
	
	
	HomeService=function()
	{
		if(this.mydataService.checkInternetFunction()=="0"){
			////console.log("Internet UnAvailable")
			}else  if(this.mydataService.checkInternetFunction()=="1"){
			var userid = window.localStorage.getItem('userid');
			//alert(userid);
			let loader = this.loading.create({content: '',});
			var kiloSabjiJSONdata = JSON.stringify({"userid":userid,"IMEI":window.localStorage.getItem('session_ids')});
			
			//console.log("Home Url--->"+this.myurlService.HOMEURL+"\n"+"JSON Parameter--->"+kiloSabjiJSONdata);
			loader.present().then(() => {
				this.mydataService.postJSON(this.myurlService.HOMEURL ,kiloSabjiJSONdata).subscribe(data => this.jsonDt= data,error => this.errorFunctions(loader,error),() =>this.homeService(loader));
			});
		}	 }
		
		errorFunctions= function(loader,error){
			loader.dismiss();
			//////console.log(error);
			//alert(error);
		}
		homeService=function(loader){
			this.categoryDt = this.jsonDt.categorydata;
			this.description=this.categoryDt[0].description;
			this.descriptiones=this.categoryDt[1].description;
			this.descriptions=this.categoryDt[2].description;
			//alert(this.description);
			//////console.log(" Home Receive jsondata ==>"+JSON.stringify(this.jsonDt.categorydata));
			loader.dismiss();
		}
		
		
		
		
		
		
		
		
		
		
		
		
		
		
		
		
		
		addcartSe=function(){
			
			var kiloSabjiJSONdata = JSON.stringify({"usediscount":"1","userid":window.localStorage.getItem('userid'),"IMEI":window.localStorage.getItem('session_ids'),"deliverytype":"Doorstep Delivery"});
			//alert(this.myurlService.MYCARTCHECKOUTCAll +"           "+kiloSabjiJSONdata);
			let loader = this.loading.create({content: '',});
			loader.present().then(() => {
				this.mydataService.postJSON(this.myurlService.MYCARTCHECKOUTCAll ,kiloSabjiJSONdata).subscribe(data => this.jsonDt= data,error => this.errorFunction(loader,error),() =>this.SendDataO(loader));
			});
		}
		
		SendDataO=function(load){
		
			let loader = this.loading.create({content: '',});
			load.dismiss();			
			var kiloSabjiJSONdata = JSON.stringify({"IMEI":window.localStorage.getItem('session_ids'),"userid":window.localStorage.getItem('userid')});
			loader.present().then(() => {
				this.mydataService.postJSON(this.myurlService.MYCARTURL ,kiloSabjiJSONdata).subscribe(data => this.jsonDt= data,error => this.errorFunction(loader,error),() =>this.cartDataServi(loader));
			});			
			
			
		}
		cartDataServi=function(loader){
			
			//////console.log("addtocartdata receive jsondata ==>"+JSON.stringify(this.jsonDt));
			//	alert("mycart other--->"+this.jsonDt);
			//alert("addtocartdata receive jsondata ==>"+JSON.stringify(this.jsonDt));
			//window.plugins.paytm.startPayment("526", "25862", "abc@gmail.com", "777777777", "25", successCallback, failureCallback);
			var sendData=null;
			this.addtocartDt = this.jsonDt.addtocartdata;
			this.orderconfigDt = this.jsonDt.orderconfig;
			this.minOrderValue = this.orderconfigDt[0].minOrderValue;
			this.deliverycharge = this.orderconfigDt[0].deliverycharge;
			this.takeawayMinValue = this.orderconfigDt[0].takeawayMinValue;
			this.cashondelivery = this.orderconfigDt[0].cashondelivery;
			
			this.totalAmountDt = this.jsonDt.totalAmount;
			this.discountAmountDt = this.jsonDt.discountAmount;
			this.deliverydatedataDt = this.jsonDt.deliverydatedata;
			loader.dismiss();
			if(this.addtocartDt.length>0){
			this.cartid = this.addtocartDt[0].cartid;}
			this.amount = this.totalAmountDt[0].amount;
			this.noofitem = this.addtocartDt.length;
			//this.totalSendAmt = this.totalAmountDt[0].amount;addtocartdetail
			
			this.addtocartDetailDt = this.jsonDt.addtocartdetail;
			
			//alert(JSON.stringify(this.addtocartDt));
			
			this.showTotalAmt=0.0;
			this.varDiscount=0.0;
			for(var j=0;j<this.addtocartDt.length;j++){
				////////console.log("ssssssssssssaddsd"+this.addtocartDt[j].discount);
				//alert("check===>"+this.addtocartDt[j].discount);
				this.varDiscount = parseFloat(this.addtocartDt[j].discount) + parseFloat(this.varDiscount);
				
				this.showTotalAmt = parseFloat(this.showTotalAmt)+(parseFloat(this.addtocartDt[j].totalAmount));
			}
			//alert("Discount===>"+this.varDiscount)
			this.userid = window.localStorage.getItem('userid');
			//alert("this.userid===>"+this.userid)
			if(this.userid!=null){
				this.finalTotalAmt = this.showTotalAmt - this.varDiscount;
				}else{
				this.finalTotalAmt=this.showTotalAmt;
			}
			
			var givenpoint = this.discountAmountDt[0].givenpoint;
			var useddiscount = this.discountAmountDt[0].useddiscount;
			////////console.log("deliverydatedataDt receive jsondata ==>"+JSON.stringify(this.jsonDt.deliverydatedata));
			window .localStorage.setItem('noofitem',this.noofitem);
			window.localStorage.setItem('totalAmount',this.amount);
		window.localStorage.setItem('useddiscount',useddiscount);
		window.localStorage.setItem('givenpoint',givenpoint);
		
		}
		orderQtyFunnn(miniQty , maxQty, orderQty , checkstatus,cartid,qty,price,parent_id){
	
	//console.log('myFunction===>'+miniQty+"   "+maxQty +"   " +orderQty+"   "+checkstatus+cartid+qty+price+"                 parent_id===>"+parent_id);
	//alert('myFunction===>'+miniQty+"   "+maxQty +"   " +orderQty+"   "+checkstatus+"   "+cartid+"  "+qty+"  "+price);
	if(checkstatus=='subitemm') {
	if (orderQty < 1) { //console.log('min qty false');
	return 1;
	} else { //console.log('min qty true');
	
	this.updateequty(cartid,orderQty,price*orderQty);
	
	return orderQty;
	}
	}else if(checkstatus=='addditem') {
	//alert(window.localStorage.getItem('localid'));
	if(parent_id!="1"){
			//console.log('parent Id is not 1');
	if (orderQty > maxQty) { //console.log('min qty false');
	
	return maxQty;
	}
	else { //console.log('min qty true');
	this.updateequty(cartid,orderQty,price*orderQty);
	return orderQty;
	}
	}
		if(parent_id=="1"){
		//console.log('parent Id 1');
			this.updateequty(cartid,orderQty,price*orderQty);
	return orderQty;
		}
	}
	}
		updateequty=function(cartid,qty,price)
		{
		//alert('update '+cartid+"   "+qty+"    "+price);
		var kiloSabjiJSONdata = JSON.stringify({"cartid":cartid,"quty":qty,"totalAmount":price});
		
		//////console.log("Product Url--->"+this.myurlService.UPDATEORDERURL+"\n"+"JSON Parameter--->"+kiloSabjiJSONdata);
		let loader = this.loading.create({content: '',});
		loader.present().then(() => {
		this.mydataService.postJSON(this.myurlService.UPDATEORDERURL ,kiloSabjiJSONdata).subscribe(data => this.jsonDt= data,error => this.errorFunction(loader,error),() =>this.updatequtys(loader));
		});
		}
		updatequtys=function(loader){
		this.msgDt = this.jsonDt.msg;
		//////console.log("msg receive jsondata ==>"+JSON.stringify(this.jsonDt.msg));
		this.addcartSe();
		loader.dismiss();
		}
		
		remove(cartid,productid)
		{
		var session_ids=window.localStorage.getItem('session_ids');
		//alert(productid);
		var kiloSabjiJSONdata = JSON.stringify({"userid":window.localStorage.getItem('userid'),"cartid":cartid,"productid":productid,"IMEI":session_ids});
		//////console.log("Product Url--->"+this.myurlService.DELETORDER+"\n"+"JSON Parameter--->"+kiloSabjiJSONdata);
		let loader = this.loading.create({content: '',});
		loader.present().then(() => {
		this.mydataService.postJSON(this.myurlService.DELETORDER ,kiloSabjiJSONdata).subscribe(data => this.jsonDt= data,error => this.errorFunction(loader,error),() =>this.deletepro(loader));
		});
		}
		
		deletepro=function(loader){
		this.msgDt = this.jsonDt.msg;
		//////console.log("msg receive jsondata ==>"+JSON.stringify(this.jsonDt.msg));
		loader.dismiss();
		this.addcartSe();
		}
		
		productview(cartid,viewType)
		{
		window.localStorage.setItem('cartid',cartid);
		window.localStorage.setItem('viewType',viewType);
		this.navCtrl.push(ProductviewPage);
		}
		continue(){
		this.navCtrl.push(MycartPage);
		}
		
		}
				


// WEBPACK FOOTER //
// ./src/pages/kilomenu/kilomenu.ts